/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { Modal, Pagination, Popover, Button, message, Switch } from 'antd';
import teacherStyleIcon from '../../assets/images/teacher-style-icon.png';
import timeIcon from '../../assets/images/time-icon.png';
import './selectTeacher.less';
import { getTeacherList, getTeacherTime, processTimeCheck } from '../../api/request.js';
import { TEACHER_HEAD_IMG } from '../../utils';
const SelectTeacher = (props) => {
    const pageSizeInitRef = useRef('7');
    const pageNumInitRef = useRef(1);
    const [pageSize, setPageSize] = useState(pageSizeInitRef.current);
    const [pageNum, setPageNum] = useState(1);
    // const [isChecked, setIsChecked] = useState(false);
    //名师预约选择的老师信息
    const [teacherInfo, setTeacherInfo] = useState({});
    //名师预约选择的时间信息
    const [teacherTimeInfo, setTeacherTimeInfo] = useState({});
    const [teacherList, setTeacherList] = useState([]);
    const [timeList, setTimeList] = useState([]);
    const [total, setTotal] = useState(0);
    const [errorMessage, setErrorMessage] = useState('暂无可选老师');

    //获取当前选中老师的时间
    const getTimesOfTeacher = async (teacherId) => {
        const { data } = await getTeacherTime({
            projectId: props.projectId,
            subjectId: props.subjectId,
            twoSubjectId: props.twoSubjectId,
            serviceTeamId: props.serviceTeamId,
            serviceType: props.serviceType,
            teacherId: teacherId
        });
        if (data.status === 0) {
            if (data.result) {
                setTimeList(data.result.list || []);
                return;
            }
            setTimeList([]);
        }
        setTimeList([]);

    };
    /* 筛选老师坐席： filterNotTime//类型：Boolean  必有字段  备注：是否筛选有坐席老师 true: 筛选 false: 不筛选 */
    const getTeachers = async (currentPage, pageSizeCurrent, filterNotTime) => {
        const { data } = await getTeacherList({
            projectId: props.projectId,
            subjectId: props.subjectId,
            twoSubjectId: props.twoSubjectId,
            serviceTeamId: props.serviceTeamId,
            serviceType: props.serviceType,
            pageNum: currentPage,
            pageSize: pageSizeCurrent,
            filterNotTime
        });
        if (data.status === 0) {
            if (data.result) {
                setTeacherList(data.result.list || []);
                setTotal(data.result.totalSize || 0);
                //默认选中第一条老师数据
                let teacher = {};
                if (data.result.list && data.result.list.length > 0) {
                    teacher = data.result.list[0];
                }
                if (currentPage === 1) {
                    setTeacherInfo(teacher);
                    getTimesOfTeacher(teacher.teacherId);
                } else {
                    setTeacherInfo({});
                    data.result.list && data.result.list.length > 0 && getTimesOfTeacher(data.result.list[0].teacherId);
                }
                return;
            }
            setTeacherList([]);
            setTotal(0);
            return;
        }
        setTeacherList([]);
        setTotal(0);
        setErrorMessage(data.message);

    };

    const pageSizeChangeHandle = (page, size) => {
        setPageSize(size);
        const current = size == pageSize ? +page : 1;
        setPageNum(current);
        getTeachers(current, size, props.isChecked);
        setTeacherInfo({});
        setTeacherTimeInfo({});
    };
    const cancelClickHandle = () => {
        props.onSelectTeacherCancel();
    };
    const cancelSureHandle = () => {
        if (!teacherInfo.teacherId || !teacherTimeInfo.classDay) {
            return message.error('请选择老师和时间');
        }
        props.onSelectTeacherSure(teacherInfo, teacherTimeInfo);
    };
    //选择老师点击
    const teacherClickHandle = (teacher) => {
        if (teacher.teacherId === teacherInfo.teacherId) {
            setTeacherInfo({});
            setTeacherTimeInfo({});
            return;
        }
        setTeacherInfo(teacher);
        setTeacherTimeInfo({});
        getTimesOfTeacher(teacher.teacherId);
    };
    //选择时间点击
    const timeClickHandle = async (timeData) => {
        if (!timeData.hadBooked) {
            return;
        }
        if (teacherTimeInfo.scheduleId === timeData.scheduleId) {//取消已选择
            setTeacherTimeInfo({});
            return;
        }
        //检验时间是否可预约
        const { data } = await processTimeCheck({
            projectId: props.projectId,
            subjectId: props.subjectId,
            serviceTeamId: props.serviceTeamId,
            startTime: `${timeData.classDay} ${timeData.times.split('-')[0]}`,
            endTime: `${timeData.classDay} ${timeData.times.split('-')[1]}`,
            serviceType: props.serviceType,
            twoSubjectId: props.twoSubjectId,
        });
        if (data.status === 0) {
            setTeacherTimeInfo(timeData);
            return;
        }
        message.error(data.message);
    };
    useEffect(() => {
        if (!props.projectId || !props.serviceType || !props.subjectId) {
            return;
        }
        setTeacherTimeInfo({});
        setTeacherInfo({});
        getTeachers(pageNumInitRef.current, pageSizeInitRef.current, props.isChecked);
    }, [props.serviceType, props.twoSubjectId, props.subjectId]);

    return (
        <Modal
            bodyStyle={{ paddingBottom: '0px', paddingTop: '0px' }}
            className="select-teacher-modal-container"
            closable={false}
            footer={[]}
            maskClosable={false}
            onCancel={() => props.onSelectTeacherCancel()}
            title="选择老师"
            visible={props.selectTeacherVisible}
            width="1190px"
        >
            <div className="select-teacher-wrapper-root">
                <div className="select-teacher-line" />
                <div
                    className="select-teacher-wrapper-left"
                    style={{
                        marginLeft: '30%',
                        marginBottom: '10px',
                    }}
                >
                    隐藏已约满
                    <Switch
                        checked={props.isChecked}
                        checkedChildren="开"
                        onChange={(e) => {
                            setPageNum(1);
                            getTeachers(1, pageSize, e);
                            props.onChecked(e);
                        }}
                        style={{ marginLeft: '10px' }}
                        unCheckedChildren="关" />
                </div>
                <div className="select-teacher-wrapper">
                    <div className="teacher-info-wrapper">
                        <div className="teacher-list-wrapper">
                            {
                                (teacherList && teacherList.length) ? teacherList.map((teacher) => (
                                    <div
                                        className={`teacher-item ${teacher.teacherId === teacherInfo.teacherId ? 'teacher-active' : ''}`}
                                        key={teacher.teacherId}
                                        onClick={() => teacherClickHandle(teacher)}
                                    >
                                        <img
                                            className="left-head-img"
                                            src={teacher.picture || TEACHER_HEAD_IMG} />
                                        <div className="right-all-info">
                                            {
                                                teacher.featureTeaching ? (
                                                    <Popover
                                                        content={teacher.featureTeaching}
                                                        title={<span className="style-title-font-blod">个人特色</span>}
                                                        trigger="hover"
                                                    >
                                                        <div className="style-icon-wrapper">
                                                            <img
                                                                className="style-icon"
                                                                src={teacherStyleIcon} />
                                                        </div>
                                                    </Popover>
                                                ) : null
                                            }
                                            <div className="title-ui">{teacher.teacherName}</div>
                                            {
                                                teacher.teachingStyle ? (
                                                    <div className="item-line-wrapper">
                                                        <div className="left-label-style text-normal-ui">
                                                            授课风格：
                                                        </div>
                                                        <div className="right-content">
                                                            <div className="tag-com-ui tag-style">{teacher.teachingStyle}</div>
                                                        </div>
                                                    </div>
                                                ) : null
                                            }

                                            {
                                                (teacher.adeptSubjects && teacher.adeptSubjects.length) ? (
                                                    <div className="item-line-wrapper">
                                                        <div className="left-label-style text-normal-ui">
                                                            擅长科目：
                                                        </div>
                                                        <div className="right-content">
                                                            {
                                                                teacher.adeptSubjects.filter((item, index) => index < 3).map((subjectItem, sIndex) => (
                                                                    <div
                                                                        className="tag-com-ui tage-subject"
                                                                        key={sIndex}
                                                                    >{subjectItem.subjectName}</div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                ) : null
                                            }

                                        </div>
                                    </div>
                                )) : <div className="teacher-empty">{errorMessage}</div>
                            }


                        </div>
                        <div className="teacher-pagination-wrapper">
                            <div className="total-text">
                                共{total}条
                            </div>
                            <Pagination
                                current={pageNum}
                                onChange={pageSizeChangeHandle}
                                pageSize={pageSize}
                                pageSizeOptions={['7', '10', '20', '30']}
                                showSizeChanger
                                total={total} />
                        </div>
                    </div>
                    <div className="middle-empty" />
                    <div className="time-info-wrapper">
                        {
                            (teacherList && teacherList.length) ? (
                                <>
                                    <div className="time-title">
                                        可选时间
                                    </div>
                                    <div className="time-content-container">
                                        {
                                            (timeList && timeList.length > 0) ? timeList.map((dayItem) => (
                                                <div
                                                    className="day-item-wrapper"
                                                    key={dayItem.classDay}
                                                >
                                                    <div className="day-line">
                                                        <img
                                                            className="time-icon"
                                                            src={timeIcon} />
                                                        <div className="text-date">{dayItem.classDay}</div>
                                                    </div>
                                                    {
                                                        dayItem.isAppointmentFull ? (
                                                            <div className="times-list-wrapper" >
                                                                <div
                                                                    className="time-lable-item"
                                                                >已约满</div>
                                                            </div>
                                                        ) : null

                                                    }
                                                    {
                                                        (!dayItem.isAppointmentFull && dayItem.timeList && dayItem.timeList.length > 0) ? (
                                                            <div className="times-list-wrapper" >
                                                                {
                                                                    dayItem.timeList.map((timeItem, index) => (
                                                                        <div
                                                                            className={`time-lable-item ${timeItem.scheduleId === teacherTimeInfo.scheduleId ? 'time-active' : ''} ${!timeItem.hadBooked ? 'time-disable' : ''}`}
                                                                            key={index}
                                                                            onClick={() => timeClickHandle({ classDay: dayItem.classDay, ...timeItem })}
                                                                        >{timeItem.times}</div>
                                                                    ))
                                                                }
                                                            </div>
                                                        ) : null
                                                    }

                                                </div>
                                            )) : (
                                                <div
                                                    className="time-lable-item-empty"
                                                >已约满</div>
                                            )
                                        }
                                    </div>
                                </>
                            ) : null
                        }

                        <div
                            className="btns-bottom-wrapper"
                            style={!(teacherList && teacherList.length > 0) ? { marginTop: 320 } : {}}
                        >
                            <Button
                                className="btn-ui"
                                onClick={cancelClickHandle}
                            >取消</Button>
                            {
                                (timeList && timeList.length > 0) ? (
                                    <Button
                                        className="btn-ui"
                                        onClick={cancelSureHandle}
                                        type="primary"
                                    >预约</Button>
                                ) : null
                            }

                        </div>
                    </div>

                </div>
            </div>
        </Modal>

    );
};

export default SelectTeacher;
